import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatRelativeTime(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input;
  const diffSec = Math.round((Date.now() - date.getTime()) / 1000);
  const abs = Math.abs(diffSec);
  const past = diffSec >= 0;
  const fmt = (n: number, unit: string) =>
    past ? `${n} ${unit}${n === 1 ? "" : "s"} ago` : `in ${n} ${unit}${n === 1 ? "" : "s"}`;
  if (abs < 45) return past ? "just now" : "in a moment";
  if (abs < 90) return fmt(1, "minute");
  if (abs < 3600) return fmt(Math.round(abs / 60), "minute");
  if (abs < 5400) return fmt(1, "hour");
  if (abs < 86400) return fmt(Math.round(abs / 3600), "hour");
  if (abs < 86400 * 2) return past ? "yesterday" : "tomorrow";
  if (abs < 86400 * 30) return fmt(Math.round(abs / 86400), "day");
  if (abs < 86400 * 365) return fmt(Math.round(abs / (86400 * 30)), "month");
  return fmt(Math.round(abs / (86400 * 365)), "year");
}

export function formatAbsoluteDateTime(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input;
  return date.toLocaleString();
}
